import { TOKEN_COLORS } from '@/constants/tokens';

export const getTokenColor = (tokenSymbol: string | undefined): string => {
  if (!tokenSymbol) return '#6C5DD3';
  const upperSymbol = tokenSymbol.toUpperCase();
  return (
    TOKEN_COLORS[upperSymbol as keyof typeof TOKEN_COLORS] ||
    `hsl(${Math.abs(
      upperSymbol.split('').reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0) % 360
    )}, 70%, 45%)`
  );
};

export const formatUSDC = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatFullyDilutedValuation = (
  value: number,
  notation: 'compact' | 'standard' | 'scientific' | 'engineering' = 'standard'
) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation,
  }).format(value);
};
